import { render, staticRenderFns } from "./billing-notes-upload-file.vue?vue&type=template&id=18ddd20d"
import script from "./billing-notes-upload-file.vue?vue&type=script&lang=js"
export * from "./billing-notes-upload-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports